import { BaseFetch } from "../main-model"
export default class EventScheduleModel extends BaseFetch {
    getEventScheduleBy = (data) =>
    this.authFetch({
      url: "event-schedule/getEventScheduleBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getEventScheduleBySchoolGroup = (data) =>
    this.authFetch({
      url: "event-schedule/getEventScheduleBySchoolGroup",
      method: "POST",
      body: JSON.stringify(data),
    })
    getEventScheduleById = (data) =>
    this.authFetch({
      url: "event-schedule/getEventScheduleById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertEventSchedule = (data) =>
    this.authFetch({
      url: "event-schedule/insertEventSchedule",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateEventScheduleId = (data) =>
    this.authFetch({
      url: "event-schedule/updateEventScheduleId",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteEventScheduleId = (data) =>
    this.authFetch({
      url: "event-schedule/deleteEventScheduleId",
      method: "POST",
      body: JSON.stringify(data),
    })
}
